import { render, staticRenderFns } from "./ForCompany.vue?vue&type=template&id=7d69b220&scoped=true&"
import script from "./ForCompany.vue?vue&type=script&lang=js&"
export * from "./ForCompany.vue?vue&type=script&lang=js&"
import style0 from "./ForCompany.vue?vue&type=style&index=0&id=7d69b220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d69b220",
  null
  
)

export default component.exports